import React from 'react'
import Raven from 'raven-js'

const defaultErrorCallback = (error, info) => {
  console.warn(error)
  console.warn(info)
}

const DefaultFallback = () =>  (
  <div
    className="snap"
    onClick={() => Raven.lastEventId() && Raven.showReportDialog()}
    >

    <p>We're sorry — something's gone wrong.</p>
    <p>Our team has been notified, but click here fill out a report.</p>
  </div>
)

      function withErrorHandler (Component, errorCallback = defaultErrorCallback, FallbackComponent = DefaultFallback) {
  class WithErrorHandler extends React.Component {
    constructor () {
      super()
  
      // Construct the initial state
      this.state = {
        hasError: false,
        error: null,
        errorInfo: null
      }
    }

    componentDidCatch (error, info) {
      console.info(error)
      console.info(info)
      // Update state if error happens
      this.setState({ hasError: true, error, errorInfo: info })
      
      // Report errors
      errorCallback(error, info, this.props)
    }

    render () {
      // if state contains error we render fallback component
      if (this.state.hasError) {
        const { error, errorInfo } = this.state
        console.log('error', this.state.hasError)
        return (
          <FallbackComponent />
        )
      }

      return <Component {...this.props} />
    }
  }
  WithErrorHandler.displayName = `withErrorHandler(${Component.displayName})`
  return WithErrorHandler
}

export default withErrorHandler



// WEBPACK FOOTER //
// ./src/errors/withErrorHandler.js